<template>
	<footer id="mobile-footer">
		<ul class="links">
			<li @click="openUrl('https://www.koreapetroleum.com/')">회사소개</li>
			<li @click="go(PageName.CsCenter.NoticeManagement)">공지사항</li>
			<li @click="go(PageName.CsCenter.QuestionManagement)">자주묻는질문</li>
			<li @click="openUrl('https://smartjack.notion.site/15d6730042364ea1a511ab382192d3f7')">이용약관</li>
			<li class="strong" @click="openUrl('https://smartjack.notion.site/d41a74be81124ea3a9fb5f91409d490f')">개인정보처리방침</li>
		</ul>
		<div class="call">
			<span>고객센터</span>
			<b>02-799-3170</b>
			<p>평일 10:00 ~ 17:00 · 점심 12:00 ~ 13:00 (토/일/공휴일 휴무)</p>
			<p>채팅 상담 · <a href="mailto:lab@lab-manager.com">lab@lab-manager.com</a></p>
		</div>
		<div class="biz">
			<p>KP한석화학(주) · 대표자: 서귀석</p>
			<p>사업자등록번호: 106-81-48000</p>
			<p>통신판매업신고: 제 2025-서울용산-0936 호</p>
			<p>서울시 용산구 이촌로 166(이촌동)</p>
			<p class="copy">COPYRIGHT © 2025 KP Hansuck Chemicals Co., Ltd.<br />All rights reserved.</p>
		</div>
		<button class="view-switch" @click="switchView">PC 버전 보기</button>
	</footer>
</template>

<script>
import PageName from '@/utils/define/PageName'
import { setViewMode } from '@/utils/device'

export default {
	name: 'MobileFooter',
	data() {
		return { PageName }
	},
	methods: {
		go(name) {
			this.$router.push({ name }).catch(() => {})
		},
		openUrl(url) {
			window.location.href = url
		},
		switchView() {
			setViewMode('pc')
		},
	},
}
</script>

<style lang="scss" scoped>
#mobile-footer {
	margin-top: 32px;
	padding: 24px 20px 32px;
	background: #f7f8fa;
	border-top: 1px solid #eceef1;
	color: #6b7280;
	font-size: 0.78rem;
	.links {
		display: flex;
		flex-wrap: wrap;
		gap: 8px 16px;
		margin: 0 0 18px;
		padding: 0;
		list-style: none;
		li {
			font-size: 0.82rem;
			cursor: pointer;
			&.strong {
				font-weight: 700;
				color: #374151;
			}
		}
	}
	.call {
		margin-bottom: 16px;
		span {
			font-size: 0.75rem;
			font-weight: 700;
		}
		b {
			display: block;
			margin: 2px 0 4px;
			font-size: 1.35rem;
			color: #161616;
		}
		p,
		a {
			margin: 0;
			white-space: normal;
			font-size: 0.76rem;
			color: #6b7280;
		}
	}
	.biz p {
		margin: 0 0 3px;
		white-space: normal;
		font-size: 0.74rem;
		line-height: 1.5;
		&.copy {
			margin-top: 10px;
			color: #9aa3ad;
		}
	}
	.view-switch {
		width: 100%;
		height: 42px;
		margin-top: 18px;
		border: 1px solid #dfe3e8;
		border-radius: 21px;
		background: #fff;
		font-size: 0.88rem;
		color: #6b7280;
	}
}
</style>
